var isFunction = require('./isFunction');
var isObject = require('./isObject');

module.exports = function isType(x) {
  return isFunction(x) && isObject(x.meta);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/isType.js
 ** module id = 50
 ** module chunks = 0
 **/